export let white = '#fff'
export let badgeBg = '#4ea3ff'
export let badgeText = white
export let badgeX = white
export let input = {
  background: white,
  placeholder: '#a4a4a4',
  text: '#1b1b1b',
}
